import React from "react";
import Context from "../../../Context";
import Scrollpane from "../../Misc/Scrollpane";
import Searchbox from "../../Misc/Searchbox";
import BsModal from "../../Misc/BsModal";
import Blocker from "../../Misc/Blocker";
import List from "../../Misc/List";
import StateLabel from "../../Essence/StateLabel";

export default class WorkdocItemInfoModal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      search: [],

      customListKey: "",
      filters: {
        show: false,
        active: [],
        default: [
          {
            field: "object",
            compare: "EQL",
            value: props.item?.id,
          },
        ],
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      sortings: {
        all: [
          {
            id: "byNameAsc",
            active: false,
            title: "По алфавиту",
            value: ["name ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }

  onSearch = (text) => {
    let search = text
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${text}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({ search });
  };

  render() {
    const { item = {} } = this.props;
    const { pending } = this.props;

    return (
      <>
        <BsModal show center lg onClose={this.props.onClose}>
          <Blocker on={pending}>
            <div className="mb-5 pb-2">
              <div className="d-flex align-items-center justify-content-between">
                <h5>{item.name || item.label || "История"}</h5>
                <div>
                  <button
                    onClick={this.props.onSwitchMode}
                    className="btn btn-light btn-icon"
                  >
                    <i className="fa fa-retweet"></i>
                  </button>
                </div>
              </div>
              <div className="d-flex mt-3">
                <div className="flex-grow-1">
                  <Searchbox onSearch={this.onSearch} />
                </div>
                <div></div>
              </div>
            </div>
            <List
              keyField="id"
              listKey="historyList"
              path="/object/method/history/list"
              key={this.state.customListKey}
              fulltext={JSON.stringify(this.state.search)}
              search={JSON.stringify(
                this.state.filters.active.concat(this.state.filters.default)
              )}
              sort={JSON.stringify(this.state.sortings.active)}
              limit={50}
              hideSinglePageNav
              table
              tableHeadings={<></>}
            >
              <ListItem />
            </List>
          </Blocker>
        </BsModal>
      </>
    );
  }
}

function ListItem(props) {
  const datetime = props.datetime ? new Date(props.datetime) : {};

  return (
    <tr>
      <td className="text-dark-50 small">
        {datetime?.toLocaleTimeString()}
        <br />
        {datetime?.toLocaleDateString()}
      </td>
      <td>{props.fullname}</td>
      <td className="text-dark-50">{props.actionname}</td>
      <td className="nowrap">
        <StateLabel
          stateCode={props.stateoldtypecode}
          stateLabel={props.stateoldlabel}
        />

        <i className="fa fa-angle-right mx-2"></i>

        <StateLabel
          stateCode={props.statenewtypecode}
          stateLabel={props.statenewlabel}
        />
      </td>
    </tr>
  );
}
